export default __webpack_public_path__ + "static/media/box16.bf1a4c23.svg";